import axios from 'axios';

/**
 * Api - Class representing axios instance.
 * Handles initial configuration and generic error handling
 */
class Api {
  constructor() {
    this.accessToken = null;
    this.appElement = document.getElementById('app');

    this.instance = axios.create({
      // API will use current url as base url
      baseURL: '',
    });

    // Default Error handling
    this.instance.interceptors.response.use(
      (res) => res,
      (err) => Promise.reject(err),
    );
  }

  /**
   * Get method
   * @param  {...any} params
   */
  get(...params) {
    return this.instance.get(...params);
  }

  /**
   * Post method
   * @param  {...any} params
   */
  post(...params) {
    return this.instance.post(...params);
  }

  /**
   * Put method
   * @param  {...any} params
   */
  put(...params) {
    return this.instance.put(...params);
  }

  /**
   * Patch method
   * @param  {...any} params
   */
  patch(...params) {
    return this.instance.patch(...params);
  }

  /**
   * Delete method
   * @param  {...any} params
   */
  delete(...params) {
    return this.instance.delete(...params);
  }
}
const api = new Api();
export default api;
